export const permissions = {
  listOrganizations: "list_organizations",
  createOrganization: "create_organization",
  updateOrganization: "update_organization",
  readOrganization: "read_organization",
  consultationAccess: "consultation_access",
  generalAccess: "general_access",
} as const;
